import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPublicPortalSiteContentUrl } from '../cms/i3CmsEndpoints';
import '../styles/I3Layout.css';

const I3Footer: React.FC = () => {
  const [liveFromSql, setLiveFromSql] = useState<boolean | null>(null);

  useEffect(() => {
    const url = getPublicPortalSiteContentUrl();
    if (!url) {
      setLiveFromSql(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(url, { cache: 'no-store' });
        if (cancelled) return;
        if (!res.ok) {
          setLiveFromSql(false);
          return;
        }
        const body = (await res.json()) as { content?: unknown };
        setLiveFromSql(body?.content != null);
      } catch {
        if (!cancelled) setLiveFromSql(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const hideBadge = process.env.REACT_APP_HIDE_I3_CMS_BADGE === 'true';
  const showLiveBadge = liveFromSql === true && !hideBadge;

  return (
    <footer className="i3-footer">
      <div className="i3-footer-inner">
        <div className="i3-footer-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/events">Events</Link>
          <Link to="/blog">Journal</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <p className="i3-footer-contact-label">Contact us via email and follow us on social media.</p>
        <div className="i3-footer-contact">
          <a href="mailto:info@i3coachingconsulting.com">info@i3coachingconsulting.com</a>
          <span className="i3-footer-sep"> · </span>
          <a href="tel:317-688-7632">317-688-7632</a>
        </div>
        <div className="i3-footer-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <span className="i3-social-icon" aria-hidden>
              f
            </span>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <span className="i3-social-icon" aria-hidden>
              📷
            </span>
          </a>
        </div>
        <p className="i3-footer-copy">© {new Date().getFullYear()} I-3 Coaching & Consulting, LLC</p>
        {showLiveBadge ? (
          <p className="i3-footer-cms-badge" title="This page is loading site content from P5 SQL (portal_site_content).">
            Content: live (P5 CMS)
          </p>
        ) : null}
      </div>
    </footer>
  );
};

export default I3Footer;
